<template>
  <!-- D: 스와이퍼 전체 -->
  <h2 class="c-title-level2" v-if="data.swiper.listFlag">
    빠른주문<small>(최근 주문 내역)</small>
  </h2>
  <div class="swiper-wrap" v-if="data.swiper.listFlag">
    <div class="swiper product-swiper" data-swiper-id="swiperCol3">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(list, idx) in data.swiper.data"
          :key="`slideSlide-${idx}`"
        >
          <!-- group -->
          <div
            class="order-group"
            v-for="(item, itemIdx) in list"
            :key="`item-${itemIdx}`"
          >
            <div class="order-info">
              <em class="order-num">
                주문번호
                <span class="system">{{ item.sapOrderNo }}</span>
              </em>
              <span class="date">{{ item.orderDt }}</span>
            </div>
            <!-- D: 메인 전용 상품 컴포넌트 -->
            <div class="c-main-product-card">
              <div class="product-thumb">
                <a
                  href="javascript:void(0);"
                  class="thumb-button"
                  @click="btnCmd('detail', item)"
                >
                  <div class="product-img">
                    <img
                      class="no-image"
                      v-if="
                        item.imgUrl == null ||
                        item.imgUrl == '' ||
                        item.noImgFlag == true
                      "
                      src="@/assets/images/common/img_no_product.svg"
                      alt="No Image"
                    />
                    <img
                      v-else
                      :src="item.imgUrl"
                      alt=""
                      @error="() => (item.noImgFlag = true)"
                    />
                  </div>
                  <div class="thumb-bottom">
                    <p class="text">주문상세보기</p>
                    <i class="c-icon icon-plus"></i>
                  </div>
                </a>
              </div>
              <div class="product-info">
                <div class="c-product-category">
                  <span class="path">{{ item.prodh1t }}</span>
                  <span class="path">{{ item.prodh2t }}</span>
                  <span class="path">{{ item.prodh3t }}</span>
                </div>
                <div class="product-code">{{ item.matnr }}</div>
                <strong class="product-name">{{ item.zzmaktx }}</strong>
                <div class="info-bottom">
                  <div class="delivery-link">
                    <a href="javascript:void(0);" @click="btnCmd('delivMng')"
                      >{{ item.dlvdesNm }}<i class="c-icon icon-arrow-gray"></i>
                    </a>
                  </div>
                  <div class="c-btn-area">
                    <button
                      type="button"
                      class="c-button type-primary type-xsmall"
                      @click="btnCmd('reOrder', { index: item.orderSn })"
                    >
                      <span>다시 주문하기</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- D: 스와이퍼 indicator 별도 적용 영역 -->
    <div class="c-swiper-indicator" data-swiper-indicator-id="swiperCol3"></div>
  </div>
</template>

<script setup name="main03Swiper">
import {
  reactive,
  inject,
  defineProps,
  watch,
  nextTick,
  ref,
  defineEmits,
} from "vue";

// import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";
import * as orderApi from "@/api/orderApi.js";

//Swiper
import Swiper, { Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";

import { api } from "@/plugins/api";
import { useRouter } from "vue-router";
const { isMobile } = cmUtil.useDeviceType();

const router = useRouter();
const url = inject("url_prefix");
const emits = defineEmits(["quickCnt"]);
const swiperInstance = ref(null);
const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;

const props = defineProps({
  type: {},
  option: {},
  data: {
    type: Object,
    required: true,
  },
});

const data = reactive({
  swiper: {
    loading: false,
    search: {},
    data: [],
    detail: [],
    listFlag: true,
  },
  info: {},
});

watch(
  () => props.data,
  () => {
    data.info = props.data;
    mainSwiper03();
  }
);

/**********************
 * 스와이퍼 호출
 *********************/
async function initSwiper() {
  if (!isMobile.value) {
    // 기존 인스턴스 파괴
    if (swiperInstance.value) {
      swiperInstance.value.destroy(true, true);
      swiperInstance.value = null;
    }

    // nextTick을 사용하여 DOM 업데이트 보장
    await nextTick();

    swiperInstance.value = new Swiper("[data-swiper-id='swiperCol3']", {
      modules: [Pagination, Autoplay],
      init: true,
      initialSlide: 0,
      speed: 400,
      loop: true,
      // loopedSlides: 1,
      slidesPerView: 1,
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      autoplay: {
        delay: data.swiper?.data.length > 1 ? 2000 : 99999000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: '[data-swiper-indicator-id="swiperCol3"]',
        type: "bullets",
        clickable: true,
      },
    });
  }
}

/**********************
 * 조회 모음
 *********************/
async function mainSwiper03() {
  const res = await api.post(`${url}/main/mainSwiper03`, {
    ...props.data,
  });

  var swiper03 = []; //스와이퍼 목록
  var itemList = []; //1페이지 2제품 리스트
  var listIdx = res.data.length - 1;
  if (res.data.length > 0) {
    res.data.forEach((item, idx) => {
      var param = {
        sapOrderNo: item.sapOrderNo,
        orderDt: item.orderDt,
        /* 뱃지영역 */
        fashionRcmdtnTurn: item.fashionRcmdtnTurn,
        zzlqdCls: item.zzlqdCls,
        zzlqdtyCls: item.zzlqdtyCls,
        setgdYn: item.setgdYn,
        prodh1t: item.prodh1t,
        prodh2t: item.prodh2t,
        prodh3t: item.prodh3t,
        /* 상품정보 */
        matnr: item.matnr,
        zzmaktx: item.zzmaktx,
        dlvdesNm: item.dlvdesNm,
        orderSn: item.orderSn,
        imgUrl: FILE_CDN_URL + item.filePath + "/" + item.physFileNm,
        noImgFlag: item.physFileNm == null ? true : false,
        goodsSn: item.goodsSn,
      };
      itemList.push(param);
      //1페이지 2제품이 되도록 리스트 나눠서 담기
      if (idx % 2 == 1) {
        swiper03.push(itemList);
        itemList = [];
      }
      //홀수인 경우 마지막 제품이 담기지 않아서 담기도록 추가
      else if (idx == listIdx) {
        swiper03.push(itemList);
      }
    });
    data.swiper.data = swiper03;

    const resDetail = await api.post(`${url}/main/mainSwiper03Detail`, {
      ...props.data,
    });

    data.swiper.detail = resDetail.data;
    data.swiper.listFlag = true;

    await nextTick();
    initSwiper();
  } else {
    data.swiper.listFlag = false;
    emits("quickCnt");
  }
}

/**********************
 * 버튼 동작 모음
 *********************/
// 자주찾는 메뉴 세팅 팝업
async function btnCmd(cmd = "", item = {}) {
  // 주문 상세보기 이동
  if (cmd == "detail") {
    router.push({
      path: `/paintpro/orderList/detail/${item.orderSn}`,
    });
  }
  // 다시 주문하기
  else if (cmd == "reOrder") {
    await orderApi.reOrder({ orderSn: item.index });
  }
  // 배송지 변경
  else if (cmd == "delivMng") {
    router.push({
      path: "/paintpro/utility/delivMng",
    });
  }
}
</script>
